<template>
  <div class="readonly-formcolor">
    <div class="breadcrumbs mb-2">
      <v-breadcrumbs divider=">" :items="breadcrumbsList">
        <template v-slot:item="{ item }">
          <v-breadcrumbs-item
            :to="{ name: item.path }"
            :disabled="item.disabled"
            exact
          >
            {{ item.text }}
          </v-breadcrumbs-item>
        </template>
      </v-breadcrumbs>
    </div>
    <PageTitle :pageHeading="pageHeading" :rightsideButton="false"> </PageTitle>
    <v-row class="tabs-row mb-5" no-gutters>
      <v-col cols="12" md="12" class="pb-0">
        <v-container class="create-ticket customize-select">
          <v-form v-model="emailForm">
            <v-row no-gutters>
              <v-col>
                <v-text-field
                  v-model="name"
                  outlined
                  label="Name"
                  :disabled="readOnly"
                >
                </v-text-field>
              </v-col>
            </v-row>

            <v-row no-gutters>
              <v-col>
                <v-text-field
                  v-model="email"
                  outlined
                  required
                  :disabled="readOnly || editAction"
                  class="required email-address"
                  label="Your Support email "
                  :error-messages="emailRules"
                  @input="$v.email.$touch()"
                  @blur="$v.email.$touch()"
                  @keydown="actionToForwardingEmail()"
                >
                </v-text-field>
              </v-col>
            </v-row>

            <h6 class="text-h6 mt-7 mb-6">
              <span class="secondary--font font-weight-medium-custom">
                Service Cloud Support Email
              </span>
            </h6>

            <v-card class="pa-5">
              <v-card-text>
                <div class="body-1 mb-2">Forward Your Emails to</div>
                <div :class="$vuetify.breakpoint.smAndDown ? '' : 'd-flex'">
                  <v-text-field
                    outlined
                    disabled
                    v-model="forwardEmail"
                    class="align-self-center forward-email"
                    hide-details
                    background-color="#FAFAFA"
                  >
                  </v-text-field>

                  <v-btn
                    v-if="!saveAction && !editAction"
                    id="connect-new-email"
                    class="mr-4 ml-2 font-weight-bold align-self-center body-2"
                    @click="generateForwardEmail"
                    :disabled="this.$v.$invalid"
                    :dark="!this.$v.$invalid"
                  >
                    <span class="secondary--font"> generate </span>
                  </v-btn>

                  <v-btn
                    v-else
                    class="
                      align-self-center
                      ml-2
                      body-2
                      font-weight-bold
                      copy-btn
                      body-2
                    "
                    outlined
                    :disabled="forwardEmail == '--'"
                    color="grey"
                    v-clipboard:copy="forwardEmail"
                    v-clipboard:success="onCopy"
                  >
                    <span class="secondary--font font-weight-bold">Copy </span>
                  </v-btn>
                </div>
                <div class="d-flex mt-5" v-if="saveAction || editAction">
                  <div><b>Note:</b></div>
                  <div class="pl-2 text-justify body-2">
                    Copy the above forwarding address into the forwarding
                    settings of your mail application e.g. Settings >
                    Forwarding.
                  </div>
                </div>
              </v-card-text>
            </v-card>
            <div class="mt-12">
              <v-divider class="my-5 mt-10"></v-divider>
            </div>
            <v-row class="mt-5">
              <v-col cols="auto">
                <v-btn
                  @click="redirectBack()"
                  outlined
                  id="cancel-action"
                  class="font-weight-bold"
                >
                  Cancel
                </v-btn>
              </v-col>
              <v-col cols="auto" v-if="readOnly">
                <v-btn dark class="font-weight-bold" @click="enableEdit()">
                  edit
                </v-btn>
              </v-col>
              <v-col cols="auto" v-else>
                <v-btn
                  v-if="editAction"
                  :disabled="this.$v.$invalid"
                  :dark="!this.$v.$invalid"
                  @click="editSupportEmail()"
                  class="font-weight-bold"
                >
                  Save
                </v-btn>

                <v-btn
                  v-else
                  id="connect-new-email"
                  class="mr-4 ml-2 font-weight-bold white--text"
                  @click="connectNewEmail"
                  :disabled="!saveAction"
                  :dark="saveAction"
                >
                  Save
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-col>
    </v-row>

    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import PageTitle from "@/components/shared/PageTitle";
import { $mailbox } from "@/services/Index";
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";
import config from "@/config";
/** custom validation for not supporting email */
const validEmail = (value) => {
  let domain = value.split("@")[1];
  return !config.INVALIDDOMAINS.includes(domain);
};

export default {
  name: "New-support-email",
  mixins: [validationMixin],
  components: {
    PageTitle,
  },
  data: () => ({
    breadcrumbsList: [
      {
        text: "Settings",
        disabled: false,
        path: "settings",
      },
      {
        text: "All Emails",
        disabled: false,
        path: "support-emails",
      },
      {
        text: "New Email",
        disabled: true,
        path: "",
      },
    ],
    pageHeading: "Connect Support Email Address",
    emailForm: false,
    name: "",
    email: "",
    selectedContact: null,
    selectorClass: "",
    cancelDialog: false,
    loading: false,
    editAction: false,
    readOnly: false,
    restore: false,
    invalidDomain: config.INVALIDDOMAINS,
    forwardEmail: "",
    saveAction: false,
  }),
  validations: {
    email: { required, email, validEmail },
  },
  computed: {
    /** generate forwarding email */
    // forwardEmail() {
    //   let email = "--";
    //   if (this.email) {
    //     if (this.email.includes("@")) {
    //       let domain = this.email.split("@")[1];
    //       let name = this.email.split("@")[0];
    //       if (domain.includes(".")) {
    //         domain = domain.replace(".", "");
    //       }
    //       email = `${domain}${name}@${config.domain}`;
    //     } else {
    //       email = `${this.email}@${config.domain}`;
    //     }
    //   }
    //   return email;
    // },

    emailRules() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.required && errors.push("Email is required");
      !this.$v.email.email && errors.push("Email is invalid");
      if (this.$v.email.email && this.email.includes("@")) {
        !this.$v.email.validEmail &&
          errors.push(
            "Public domain not supported. Please use your domain specific email address."
          );
      }
      return errors;
    },
  },

  watch: {
    email(val) {
      this.email = this.email.toLowerCase(val);
    },
  },
  mounted() {
    if (this.$route.params.id) {
      this.getSingleEmailData(this.$route.params.id);
      this.readOnly = true;
    }
    if (this.$route.path.indexOf("edit") > 1) {
      this.readOnly = false;
      this.editAction = true;
    }
  },

  methods: {
    actionToForwardingEmail() {
      if (this.saveAction == true) {
        this.saveAction = false;
      }
    },

    redirectBack() {
      this.$router.push({ name: "support-emails" });
    },

    enableEdit() {
      this.readOnly = false;
      this.editAction = true;
    },

    emailPayload() {
      let payload = {
        mailbox: {
          name: this.name,
          email: this.email.toLowerCase(),
          //forward_email: this.forwardEmail,
        },
      };
      return payload;
    },

    /** On click of save button connectNewEmail() function */
    async connectNewEmail() {
      let payload = this.emailPayload();
      let config = {};
      if (!this.$v.$invalid) {
        this.loading = true;
        try {
          const response = await $mailbox.create(payload, config);
          if (response.data) {
            this.redirectBack();
            this.forwardEmail = response.data.forward_email;
            this.$store.dispatch("ui/snackbar", [
              {
                title: "Support Email ",
                message: `New Support email has been added.`,
                type: "success",
              },
            ]);
            this.loading = false;
            this.$route.params.id = response.data.id;
            this.enableEdit();
          }
        } catch (error) {
          this.loading = false;
          if (error.response !== undefined) {
            this.$store.dispatch("ui/snackbar", [
              {
                title: "Error",
                message: this.$errors(error.response.data).msg({
                  capitalize: false,
                  prepend: `${this.$errors(
                    error.response.data
                  ).subjectText()} `,
                }),
                type: "error",
              },
            ]);
          }
        }
      }
    },

    async editSupportEmail() {
      let payload = this.emailPayload();
      let config = {};
      if (!this.$v.$invalid) {
        this.loading = true;
        try {
          const response = await $mailbox.update(
            this.$route.params.id,
            payload,
            config
          );
          if (response.data) {
            this.redirectBack();
            this.$store.dispatch("ui/snackbar", [
              {
                title: "",
                message: `Support email details has been updated`,
                type: "success",
              },
            ]);
            this.loading = false;
          }
        } catch (error) {
          this.loading = false;
          if (error.response !== undefined) {
            this.$store.dispatch("ui/snackbar", [
              {
                title: "Error",
                message: this.$errors(error.response.data).msg({
                  capitalize: false,
                  prepend: `${this.$errors(
                    error.response.data
                  ).subjectText()} `,
                }),
                type: "error",
              },
            ]);
          }
        }
      }
    },

    /* eslint-disable */
    async getSingleEmailData(id) {
      this.loading = true;
      try {
        const response = await $mailbox.getSingle(id, {});
        if (response.data) {
          this.updateFields(response.data);
          this.loading = false;
        }
      } catch (error) {}
    },

    /* eslint-disable */
    async generateForwardEmail() {
      this.loading = true;
      let payload = {
        email: this.email.toLowerCase(),
      };
      try {
        const response = await $mailbox.forwardEmail(payload, {});
        if (response.data) {
          this.forwardEmail = response.data.forward_email;
          this.loading = false;
          this.saveAction = true;
        }
      } catch (error) {
        if (error.response !== undefined) {
          this.$store.dispatch("ui/snackbar", [
            {
              title: "Error",
              message: this.$errors(error.response.data).msg({
                capitalize: false,
                prepend: `${this.$errors(error.response.data).subjectText()} `,
              }),
              type: "error",
            },
          ]);
        }
      }
    },

    updateFields(data) {
      this.name = data.name;
      this.pageHeading = "Edit Support Email Address";
      this.email = data.email;
      this.breadcrumbsList[2].text = this.email;
      this.forwardEmail = data.forward_email;
    },

    onCopy(e) {
      const button = e.trigger;
      const text = button.querySelector(".v-btn__content");
      this.deactivateBtn(button, text);
      this.$store.dispatch("ui/snackbar", [
        {
          title: "",
          message: "Forward email has been copied to your clipboard",
          type: "success",
        },
      ]);

      setTimeout(() => {
        this.reactivateBtn(button, text);
      }, 3000);
    },
    deactivateBtn(button, text) {
      button.setAttribute("disabled", "disabled");
      button.classList.add("v-btn--disabled");
      button.classList.add("theme--light");
      text.innerText = "Copied";
    },

    reactivateBtn(button, text) {
      button.removeAttribute("disabled");
      button.classList.remove("v-btn--disabled");
      text.innerText = "Copy";
    },
  },
};
</script>

<style lang="scss">
.email-address.v-input--is-disabled input {
  color: rgba(0, 0, 0, 0.38) !important;
}
.email-address input {
  text-transform: inherit !important;
}
.forward-email {
  margin-top: 2px;
  input {
    text-transform: lowercase !important;
  }
}
.copy-btn span {
  color: #000 !important;
}
.copy-btn.v-btn--disabled span {
  color: grey !important;
}
</style>
